"use strict";
(function(global) {
    class DdosChartProtocolController {
        constructor(config) {
            this.settings = {
                charts: {
                    barChart: {
                        dataName: "column_data",
                        id: "bar-chart"
                    }
                },
                colors: {
                    low: "250, 220, 0",
                    medium: "255, 132, 51",
                    high: "213, 71, 51"
                }
            };
            this.init(config);
        }

        init(config) {
            this.loadDataChart(config, this.settings);
            this.createGrid(config);
        }

        loadDataChart(config, settings) {

            const me = this;
            const cardActions = $('.loading').parents('.card').find('.card-header').find('.actions');
            $(document).bind('ajaxStart', function() {
                $('.loading').show('fast');
                $('.chart-title').hide();
                cardActions.css('opacity', 0);
            })
                .bind('ajaxStop', function() {
                    $('.loading').animate({
                        opacity: 0
                    }, function() {
                        $(this).hide();
                    });
                    $('.chart-title').show();
                    cardActions.css('opacity', 1);
                })

            ApiConnect.get(config.chart_data_url).then(function(data) {
                    me.drawCharts(data, settings);
                })
                .catch(function(errorThrown) {
                    console.log('Błąd wczytywania danych: ', errorThrown);
                }).finally(() => {
                    $('.loading').animate({
                        opacity: 0
                    }, function() {
                        $(this).hide();
                    });
                    $('.chart-title').show();
                    cardActions.css('opacity', 1);
                });
        }

        drawCharts(data, settings) {
            this.lineChart = new NS.Charts.DdosProtocolChart({
                "container-id": settings["charts"]["barChart"]["id"],
                "data": data["data"][settings["charts"]["barChart"]["dataName"]],
                "label_y" : data["data"]["label_y"],
                "default_show" : data["data"]["default_show"],
                "multidata": true,
                'show_legend': true
            });
        }

        createGrid(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Aplikacja",
                    "dataIndex": "application",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                }, {
                    "label": "Rodzaj",
                    "dataIndex": "type",
                    "dataType": "text",
                    "isEditable": false,
                    "width": "*"
                }, {
                    "label": "Suma",
                    "dataIndex": "value",
                    "dataType": "text",
                    "isEditable": false
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId"
            });

            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "showAllRows" : config.show_all_rows || false,
                "pageSize": (config.show_all_rows)? 99999999 : 20,
                'listeners': {
                    'onDataChanged': function() {

                    },
                    'onDataSaved': function() {

                    },
                    'onDataInvalid': function() {

                    },
                    'onDataError': function() {

                    },
                    'onSelectionChange': function(ids) {

                    }
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.DdosChartProtocolController = DdosChartProtocolController || {};

})(window);
